import { Badge, Button } from '@seen/ui'
import { IconCopy, IconPhone } from '@tabler/icons-react'
import type { ReactNode } from 'react'
import { toast } from 'sonner'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'
import { ExternalTextLink } from '#src/components/index.ts'

export function PhoneBadge({
  phoneNumber,
}: {
  phoneNumber: string
}): ReactNode {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant="outline" className="flex select-none">
          <IconPhone className="size-2.5 shrink-0" /> {phoneNumber}
        </Badge>
      </TooltipTrigger>
      <TooltipContent onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-4">
          <span>
            Phone{' '}
            <ExternalTextLink href={`tel:${phoneNumber}`}>
              {phoneNumber}
            </ExternalTextLink>
          </span>
          <Button
            variant="ghost"
            size="icon"
            className="-m-3"
            onClick={() => {
              void navigator.clipboard.writeText(phoneNumber)
              toast.success(`${phoneNumber} copied to clipboard`)
            }}
          >
            <IconCopy className="size-4" />
          </Button>
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
